/**
 * Top tab navigation. Active state via amber underline.
 */

import { NavLink } from 'react-router-dom'

interface Tab {
  to: string
  label: string
  end?: boolean
  align?: 'left' | 'right'
}

const TABS: Tab[] = [
  { to: '/', label: 'Posture', end: true },
  { to: '/performance', label: 'Performance' },
  { to: '/positions', label: 'Positions' },
  { to: '/discovery', label: 'Discovery' },
  { to: '/execution', label: 'Execution' },
  { to: '/activity', label: 'Activity' },
  { to: '/risk', label: 'Risk' },
  { to: '/alerts', label: 'Alerts' },
  { to: '/system', label: 'System' },
]

export function TabNav() {
  return (
    <nav
      aria-label="Primary navigation"
      className="flex items-center gap-8 overflow-x-auto border-b border-rule px-8"
    >
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            [
              'flex items-center gap-2 py-3.5 -mb-px font-mono text-[11px] font-medium uppercase tracking-[0.12em]',
              'border-b-2 transition-colors',
              isActive ? 'border-amber text-bone' : 'border-transparent text-muted hover:text-bone',
              tab.align === 'right' ? 'ml-auto' : '',
            ]
              .filter(Boolean)
              .join(' ')
          }
        >
          <span>{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
